import React from 'react'
import { Grid } from '@material-ui/core'
// @ts-ignore
import { EditableReactSelect } from '../../../../components/common/EditableComponents'
import { ReactSelectOption } from '../../../../types'
import { IAppTarget, IShop } from '../../../../models/contracts/shop'
import { getShopListAPI } from '../../../../api/shopV2'
import { ShopOption } from '../MigrateCompanyProductsPage'
import ErrorIcon from '@material-ui/icons/Error'
interface CustomOptionProps {
  option: ShopOption
  onSelect: (option: ShopOption) => void
  optionClassName?: string
  optionComponent?: React.ComponentType<any>
}

const CustomShopOption: React.FC<CustomOptionProps> = ({ option, onSelect, optionClassName }) => {
  const isMissingFields = option.isMissingAddress || option.isMissingState || option.isMissingEmail
  const style = {
    backgroundColor: isMissingFields ? '#cccccc' : 'inherit',
    color: isMissingFields ? 'white' : 'inherit',
    padding: '8px 12px',
    cursor: 'pointer',
    borderRadius: '4px',
    margin: '1px 0',
    display: 'flex',
    alignItems: 'center',
  }

  return (
    <div style={style} onClick={() => onSelect(option)} className={optionClassName}>
      {isMissingFields && (
        <span style={{ marginRight: '8px' }}>
          <ErrorIcon />
        </span>
      )}
      {option.label}
    </div>
  )
}

const CustomShopValue = (props: any) => {
  const isMissingFields =
    props.value.isMissingAddress || props.value.isMissingState || props.value.isMissingEmail
  const color = isMissingFields ? '#cccccc' : 'rgba(0,126,255,0.08)'

  const handleRemove = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (props.onRemove) {
      props.onRemove(props.value)
    }
  }

  return (
    <div
      style={{
        backgroundColor: color,
        color: isMissingFields ? 'white' : '#007eff',
        borderRadius: 4,
        border: isMissingFields ? '1px solid #cccccc' : '1px solid rgba(0,126,255,0.24)',
        padding: '2px 0px',
        margin: '2px',
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      <span
        style={{
          cursor: 'pointer',
          borderBottomLeftRadius: 2,
          borderTopLeftRadius: 2,
          borderRight: isMissingFields ? '1px solid #cccccc' : '1px solid rgba(0,126,255,0.24)',
          padding: '1px 5px 3px',
        }}
        onClick={handleRemove}
      >
        ×
      </span>
      <span style={{ paddingInline: 5 }}>{props.children}</span>
    </div>
  )
}

interface CompanySelectorProps {
  companies: ReactSelectOption[]
  selectedCompany: ReactSelectOption | undefined
  onCompanyChange: (company: ReactSelectOption) => Promise<void>
}

export const CompanySelector: React.FC<CompanySelectorProps> = ({
  companies,
  selectedCompany,
  onCompanyChange,
}) => {
  return (
    <Grid container>
      <Grid item xs={12} className="full-width">
        <h2 className="font-normal">Companies</h2>
        <EditableReactSelect
          placeholder={'Companies'}
          multi={false}
          valueToRender={(selectedCompany && selectedCompany.label) || ''}
          editMode={true}
          value={selectedCompany}
          onChange={onCompanyChange}
          type="text"
          InputLabelProps={{
            shrink: true,
          }}
          options={companies}
        />
      </Grid>
    </Grid>
  )
}

interface ShopSelectorProps {
  shops: ShopOption[]
  selectedCompany: ReactSelectOption | undefined
  selectedShops: ShopOption[] | undefined
  isGettingShops: boolean
  onShopChange: (shops: ShopOption[]) => Promise<void>
}

export const ShopSelector: React.FC<ShopSelectorProps> = ({
  shops,
  selectedCompany,
  selectedShops,
  isGettingShops,
  onShopChange,
}) => {
  return (
    <Grid container>
      <Grid item xs={12} className="full-width">
        <h2 className="font-normal">Shops</h2>
        <EditableReactSelect
          placeholder={'Shops'}
          multi={true}
          editMode={true}
          closeOnSelect={false}
          value={selectedShops}
          disabled={!selectedCompany || isGettingShops}
          onChange={onShopChange}
          type="text"
          InputLabelProps={{
            shrink: true,
          }}
          options={shops}
          optionComponent={CustomShopOption}
          valueComponent={CustomShopValue}
        />
      </Grid>
    </Grid>
  )
}

interface CompanyShopSelectorProps extends CompanySelectorProps, ShopSelectorProps {}

export const CompanyShopSelector: React.FC<CompanyShopSelectorProps> = ({
  companies,
  shops,
  selectedCompany,
  selectedShops,
  isGettingShops,
  onCompanyChange,
  onShopChange,
}) => {
  return (
    <Grid container spacing={24} direction="column">
      <Grid item>
        <CompanySelector
          companies={companies}
          selectedCompany={selectedCompany}
          onCompanyChange={onCompanyChange}
        />
      </Grid>
      <Grid item>
        <ShopSelector
          shops={shops}
          selectedCompany={selectedCompany}
          selectedShops={selectedShops}
          isGettingShops={isGettingShops}
          onShopChange={onShopChange}
        />
      </Grid>
    </Grid>
  )
}

export const getRetailShopsByCompanyId = async (companyId: string) => {
  try {
    const shops = await getShopListAPI({ companyId })
    const retailShops = (shops || []).filter((shop) => shop.appTarget === IAppTarget.RETAIL)
    return retailShops
  } catch (error) {
    console.error(error)
    return []
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/MigrateCompanyProducts/CompanyShopSelector.tsx